<!-- Navigation -->
<fuse-vertical-navigation class="bg-accent-900 print:hidden" [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'" [navigation]="navigation" [opened]="!isScreenSmall">
    <!-- Navigation header hook -->

    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex items-center w-full p-4 pl-5">
            <div class="flex items-center justify-center">
                <img class="w-18" src="assets/images/logo_silvestre/Cautivo2.png">
            </div>
            <!-- Components -->
            <div class="flex items-center ml-auto">
                <user [showAvatar]="false"></user>
            </div>
        </div>
        <!-- User -->
        <div class="flex flex-col items-center w-full p-4">
            <div class="flex flex-col items-center justify-center w-full mt-4">
                <div
                    class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center leading-normal text-white font-medium flex flex-col uppercase">
                    {{user.razonSocial}}
                    <span class="font-semibold text-xs text-white uppercase">{{user.nombreCompleto}}</span>
                    <span class="font-semibold text-xs text-white">{{user.perfil}}</span>
                </div>
            </div>
        </div>
    </ng-container>
    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationContentFooter>
        <div class="flex flex-0 items-center justify-center h-16 pr-6 pl-2 mt-2 mb-4 opacity-12">
            <img class="max-w-48" src="assets/images/logo_silvestre/Cautivo3.png">
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')" title="Menu">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <languages></languages>
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <search [appearance]="'bar'"></search>
        </div>
    </div>


    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <router-outlet *ngIf="true"></router-outlet>
    </div>

</div>

